import React, { useState } from "react"
import { useSnackbar } from "notistack"
import { useSelector } from "react-redux"
import CameraAltIcon from "@material-ui/icons/CameraAlt"
import FlipCameraAndroidIcon from "@material-ui/icons/FlipCameraAndroid"
import ImageList from "@material-ui/core/ImageList"
import ImageListItem from "@material-ui/core/ImageListItem"
import ImageListItemBar from "@material-ui/core/ImageListItemBar"
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core"
import axiosInstance from "src/utils/axios"
import CustomModal from "src/components/Common/CustomModal"
import {
  selectCamaraGarita,
  selectConjunto,
} from "src/redux/slices/complexSlice"

const CamarasConjunto = () => {
  const { enqueueSnackbar } = useSnackbar()
  const conjunto = useSelector(selectConjunto)
  const camaraGarita = useSelector(selectCamaraGarita)

  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [imagenes, setImagenes] = useState([])
  const date = new Date().toLocaleDateString()
  const time = new Date().toLocaleTimeString()

  const handleOpen = () => {
    setOpen(true)
    obtenerImagenes()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const obtenerImagenes = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get("captura_camaras/", {
        params: { id_conjunto: conjunto.id, camaraGarita },
      })
      if (res.data !== "") {
        setImagenes(res.data.listaImagenes)
      } else {
        enqueueSnackbar("Error al obtener las imágenes", { variant: "error" })
      }
    } catch (error) {
      enqueueSnackbar("Error al obtener las imágenes", { variant: "error" })
    }
    setLoading(false)
  }

  return (
    <>
      <Tooltip title="Ver cámaras">
        <IconButton className="mx-2" onClick={handleOpen} color="primary">
          <CameraAltIcon />
        </IconButton>
      </Tooltip>
      <CustomModal
        isOpen={open}
        closeModal={handleClose}
        title={`Cámaras: ${camaraGarita || ""}`}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" my={5}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <Typography>{`Fecha: ${date} - Hora: ${time}`}</Typography>
                <Typography variant="caption">
                  {`Conjunto: ${conjunto.Nombre || ""}`}
                </Typography>
              </div>
              <Tooltip title="Actualizar imágenes">
                <IconButton color="primary" onClick={obtenerImagenes}>
                  <FlipCameraAndroidIcon />
                </IconButton>
              </Tooltip>
            </Box>
            <ImageList cols={2} rowHeight={100}>
              {imagenes.map(item =>
                item.imagen ? (
                  <ImageListItem key={item.imagen} cols={1} rows={2}>
                    <img
                      src={`data:image/png;base64,${item.imagen}`}
                      alt={item.fuente}
                    />
                    <ImageListItemBar
                      title={item.fuente}
                      position="top"
                      actionPosition="left"
                    />
                  </ImageListItem>
                ) : null
              )}
            </ImageList>
          </>
        )}
      </CustomModal>
    </>
  )
}

export default CamarasConjunto
